import { FolderKanban } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useProjects } from '@/hooks/use-projects';
import { useGetOrCreateProjectWorkGroup } from '@/hooks/use-workgroups';

export function ProjectWorkGroupPanel() {
  const { data: projects, isLoading, error } = useProjects();
  const openProjectWorkGroup = useGetOrCreateProjectWorkGroup();

  return (
    <Card className="border-border">
      <CardHeader className="space-y-1">
        <div className="flex items-center gap-2 text-foreground">
          <FolderKanban className="h-4 w-4" aria-hidden />
          <CardTitle className="text-base">Project work groups</CardTitle>
        </div>
        <CardDescription>
          Open a WeTicket project&apos;s shared files. Project work groups are created on demand.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Loading projects…</p>
        ) : error ? (
          <p className="text-sm text-destructive">Could not load projects.</p>
        ) : !projects?.length ? (
          <p className="text-sm text-muted-foreground">No accessible projects.</p>
        ) : (
          <ul className="divide-y divide-border rounded-md border border-border">
            {projects.map((project) => (
              <li
                key={project.id}
                className="flex flex-wrap items-center justify-between gap-2 px-3 py-2"
              >
                <span className="text-sm text-foreground">{project.name}</span>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={openProjectWorkGroup.isPending}
                  onClick={() => openProjectWorkGroup.mutate(project.id)}
                >
                  Open
                </Button>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
